import React, { useContext, useEffect, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import ItemImage from '../../_common/ItemImage';
import Context from '../../../setup/context';

const ItemRowTop = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;
`

const ItemRowBottom = styled.div`
  display: flex;
  width: 100%;
  justify-content: flex-end;
  align-items: center;
  gap: 0.75rem;
  margin-top: 0.35rem;

  span {
    font-size: 0.85rem;
    color: #333;
    line-height: 1.2;
  }

  @media (min-width: 601px) {
    flex-direction: column;
    align-items: flex-end; /* stack vertically, right-align both */
    gap: 0.2rem;
    justify-content: flex-end;
  }
`

const ItemRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0.5rem 0.75rem;
  border-bottom: 1px solid #ddd;
  transition: background 0.2s;

  @media (min-width: 601px) {
    flex-direction: row;
    align-items: center;
    /* Align ItemRowTop and ItemRowBottom horizontally on desktop */
    ${ItemRowTop} {
      flex: 2;
      flex-direction: row;
      align-items: center;
      width: auto;
    }
    ${ItemRowBottom} {
      flex: 1;
      justify-content: flex-end;
      margin-top: 0;
      width: auto;
    }
  }
`

const ImageCol = styled.div`
  flex: 0 0 70px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const DetailsCol = styled.div`
  flex: 2;
  padding: 0 0.75rem 0 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  min-width: 0;

  p {
    margin: 2px 0;
  }
`

const ItemCode = styled.p`
  font-size: 0.95rem;
  font-weight: 600;
  color: #222;
  margin: 0;
`

const Desc = styled.p`
  font-size: 0.8rem;
  color: #555;
  margin: 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  line-height: 1.2rem;
  max-height: 2.4rem;
`

const AHCCode = styled.p`
  font-size: 0.7rem;
  color: #777;
  margin: 0;
`

const Wrapper = styled.div`
  all: unset;
  width: 100%;

  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  background-color: #fff;
  font-family: Arial, sans-serif;
  flex-grow: 1;
  overflow: hidden; 
`

const ScrollableItems = styled.div`
  max-height: 100%;
  overflow-y: auto;
  overscroll-behavior: contain;
  scroll-behavior: smooth;

  /* WebKit browsers (Chrome, Safari, Edge) */
  &::-webkit-scrollbar {
    width: 16px;
  }

  &::-webkit-scrollbar-track {
    background: #2c2c2c;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #555;
    border-radius: 8px;
    border: 4px solid #2c2c2c;
  }

  /* Firefox */
  scrollbar-width: thick;
  scrollbar-color: #555 #2c2c2c;
`

const FooterWrapper = styled.div`
  border-top: 1px solid #ddd;
  background: #fafafa;
  padding: 1rem;
`

const FooterRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 0.5rem;
  font-weight: 600;
  font-size: 0.95rem;

  @media (max-width: 400px) {
    flex-direction: row;
    justify-content: space-between;
  }
  display: flex;
  justify-content: space-between;
  font-weight: 600;
  font-size: 0.95rem;
`

const FooterInfo = styled.div`
  flex: 1;
  min-width: 100px;
  text-align: left;
  word-break: break-word;
  flex: 1;
  text-align: right;
  min-width: 150px;
`

const ButtonRow = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
`

const DivCheckoutButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  max-width: 300px;

	display: flex;
	align-items: center;
	justify-content: center;
	background-color: #db1633;
	background-image: linear-gradient(to top left, #950f23, #DB1633);
	color: white;
	padding: 8px 16px;
	cursor: pointer;
	width: 250px;
	margin: 8px 0;
	box-shadow: 1px 1px 2px #000;
    border: 0;
	transition: background 0.2s ease;

	p {
		margin: 0;
		margin-left: 8px;
		font-size: 18px;
		font-weight: 500;
	}

    &:hover {
        background-image: linear-gradient(to top left, #b6162b, #f52b4a);
    }

  @media (max-width: 500px) {
    width: 100%;
  }
`

const ViewCartButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 48px;
  max-width: 300px;

	display: flex;
	align-items: center;
	justify-content: center;
	background-color: white;
	color: #db1633;
	border: 2px solid #db1633;
	padding: 8px 16px;
	cursor: pointer;
	width: 250px;
	margin: 8px 0;
	box-shadow: 1px 1px 2px #000;

	p {
		margin: 0;
		margin-left: 8px;
		font-size: 18px;
		font-weight: 500;
	}

    &:hover {
        background-color: #ffe5e9;
    }

  @media (max-width: 500px) {
    width: 100%;
  }
`

const ButtonColumn = styled.div`
  flex: 1 1 100%;
  max-width: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 45%;
  min-width: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
`

const SkeletonBox = styled.div`
  background: #e0e0e0;
  border-radius: 4px;
  animation: pulse 1.5s ease-in-out infinite;
  @keyframes pulse {
    0% { opacity: 1; }
    50% { opacity: 0.4; }
    100% { opacity: 1; }
  }
`

function SkeletonRow() {
  return (
    <ItemRow>
      <ItemRowTop>
        <ImageCol>
          <SkeletonBox style={{ width: 60, height: 60 }} />
        </ImageCol>
        <DetailsCol>
          <SkeletonBox style={{ width: "70%", height: 16, marginBottom: 8 }} />
          <SkeletonBox style={{ width: "50%", height: 14 }} />
        </DetailsCol>
      </ItemRowTop>
      <ItemRowBottom>
        <span>
          <SkeletonBox style={{ width: 40, height: 16, marginRight: 8 }} />
        </span>
        <span>
          <SkeletonBox style={{ width: 60, height: 16 }} />
        </span>
      </ItemRowBottom>
    </ItemRow>
  );
}

export default function ShoppingCartPreview() {
  const { cart, cartData } = useContext(Context);
  const navigate = useNavigate();
  const scrollRef = useRef(null);

  const mergedCartData = useMemo(() => {
    if (!cartData?.itemDetails || !cartData?.itemPrices || !cart?.length) {
      return [];
    }

    return cart.map(item => {
      const invMastUid = item.invMastUid;
      const itemDetails = cartData.itemDetails.find(d => d.invMastUid === invMastUid) || {};
      const pricing = cartData.itemPrices.find(p => p.invMastUid === invMastUid) || {};

      return {
        ...item,
        itemDetails,
        pricing
      };
    });
  }, [cartData, cart]);

  // auto-scroll effect
  useEffect(() => {
    if (scrollRef.current && mergedCartData.length > 0) {
      scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
    }
  }, [mergedCartData]);

  const totalQty = mergedCartData.reduce((total, item) => total + item.quantity, 0);
  const subtotal = mergedCartData.reduce((total, item) =>
    total + (item.quantity * (item.pricing?.unitPrice || 0)), 0);

  // Update the loading condition
  const isLoading = !cartData?.itemDetails || !cartData?.itemPrices;

  return (
    <Wrapper>
      {(!mergedCartData.length || isLoading) ? (
        // Show skeleton when data is loading OR when cart is empty/not initialized
        <>
          <ScrollableItems>
            <SkeletonRow />
          </ScrollableItems>
          <FooterWrapper>
            <FooterRow>
              <FooterInfo>
                <SkeletonBox style={{ width: 100, height: 16 }} />
              </FooterInfo>
              <FooterInfo>
                <SkeletonBox style={{ width: 120, height: 16 }} />
              </FooterInfo>
            </FooterRow>
          </FooterWrapper>
        </>
      ) : (
        <>
          <ScrollableItems ref={scrollRef}>
            {mergedCartData.map((cartItem, index) => {
              const isLastItem = index === mergedCartData.length - 1;
              const hasDetails = !!cartItem?.itemDetails?.itemCode;
              const hasPricing = typeof cartItem?.pricing?.unitPrice === 'number';

              if (isLastItem && (!hasDetails || !hasPricing)) {
                return <SkeletonRow key={`skeleton-${index}`} />;
              }

              return (
                <ItemRow key={`${cartItem.invMastUid}-${index}`}>
                  <ItemRowTop>
                    <ImageCol>
                      <ItemImage details={cartItem?.itemDetails} size="THUMB" />
                    </ImageCol>
                    <DetailsCol>
                      <ItemCode>{cartItem?.itemDetails?.itemCode}</ItemCode>
                      <Desc>{cartItem?.itemDetails?.itemDesc}</Desc>
                      <AHCCode>AHC{cartItem?.invMastUid}</AHCCode>
                    </DetailsCol>
                  </ItemRowTop>
                  <ItemRowBottom>
                    <span>Qty: {cartItem?.quantity}</span>
                    <span>${cartItem?.pricing?.unitPrice.toFixed(2)} / EA</span>
                  </ItemRowBottom>
                </ItemRow>
              );
            })}
          </ScrollableItems>
          <FooterWrapper>
            <FooterRow>
              <FooterInfo>
                <strong>Quantity:</strong> {totalQty}
              </FooterInfo>
              <FooterInfo>
                <strong>Subtotal:</strong> {
                  isNaN(subtotal) ? '--' : `$${subtotal.toFixed(2)}`
                }
              </FooterInfo>
            </FooterRow>
          </FooterWrapper>
        </>
      )}

      <ButtonRow>
        <ButtonColumn>
          <ViewCartButton onClick={() => navigate("/cart")}>
            View Cart
          </ViewCartButton>
        </ButtonColumn>
        {/* TODO: The checkout button needs to do checks on the cart for example 0 priced item check. */}
        {/* <ButtonColumn>
          <DivCheckoutButton onClick={() => navigate("/checkout2")}>
            Secure Checkout
          </DivCheckoutButton>
        </ButtonColumn> */}
      </ButtonRow>
    </Wrapper>
  );
}
